import { render, staticRenderFns } from "./select-field-multiple.vue?vue&type=template&id=5bae07e6"
import script from "./select-field-multiple.vue?vue&type=script&lang=js"
export * from "./select-field-multiple.vue?vue&type=script&lang=js"
import style0 from "./select-field-multiple.vue?vue&type=style&index=0&id=5bae07e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports